module.exports = __webpack_public_path__ + "img/tmp.5046ba72.svg";